import React from 'react';
import c from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_NORMAL,
  SCREEN_TABLET,
  NODE_TYPE_FRONT_PAGE,
} from '../../config/constants';

import Breadcrumbs from '../Breadcrumbs';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { prependApiURLToImageStyles } from '../../helpers/prependApiURL';
import HeroContentImage from './ContentImage';

import './style.scss';

const Hero = ({ title, body, imageField, noBackground, button, type, noCenter }) => {
  const { width } = useWindowDimensions();

  const hasImage = imageField && imageField.get('styles');
  if (hasImage) {
    imageField = prependApiURLToImageStyles(imageField);
  }

  return (
    <div className="Hero">
      <div className={c('Hero__inner', {
        'Hero__inner--no-bg': noBackground,
        'Hero__has-image': hasImage,
      })}>
        <Container>
          <div className="row">
            {!noBackground && (
              <div className="col-12">
                <div className="Hero__breadcrumbs">
                  <Breadcrumbs includeCurrent />
                </div>
              </div>
            )}
            <div className={c('col-12', {
              'col-md-10': hasImage,
              'col-lg-7': hasImage,
            })}>
              <div className={c('Hero__content', {
                'Hero__content--no-center': noCenter,
              })}>
                <div className="Hero__content__text">
                  <h1>
                    <WysiwygField
                      property="schema:text"
                      html={title}
                    />
                  </h1>
                  {body && (
                    <WysiwygField
                      className="text-large"
                      property="schema:text"
                      html={body}
                    />
                  )}
                  {button}
                </div>
              </div>
            </div>
            {hasImage && type === NODE_TYPE_FRONT_PAGE && (
              width >= SCREEN_TABLET && width < SCREEN_NORMAL ? (
                <div className="col-12">
                  <HeroContentImage nodeType={type} imageField={imageField} />
                </div>
              ) : (
                <div className="col-lg-5 col-12">
                  <HeroContentImage nodeType={type} imageField={imageField} />
                </div>
              )
            )}
          </div>
        </Container>
      </div>
      {hasImage && type !== NODE_TYPE_FRONT_PAGE && (
        width >= SCREEN_TABLET && width < SCREEN_NORMAL ? (
          <div className="col-12">
            <HeroContentImage nodeType={type} imageField={imageField} />
          </div>
        ) : (
          <Container className="Hero__image-container">
            <div className="row">
              <div className="col-lg-5 col-12">
                <HeroContentImage nodeType={type} imageField={imageField} />
              </div>
            </div>
          </Container>
        )
      )}
    </div>
  );
};

export default Hero;
